import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-2 col-sm-6" }
const _hoisted_6 = { class: "form-group mb-4" }
const _hoisted_7 = { class: "col-lg-3 col-sm-6" }
const _hoisted_8 = { class: "form-group mb-4" }
const _hoisted_9 = { value: null }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-lg-2 col-sm-6" }
const _hoisted_12 = { class: "form-group mb-4" }
const _hoisted_13 = { value: null }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "col-lg-2 col-sm-6" }
const _hoisted_16 = { class: "form-group mb-4" }
const _hoisted_17 = { value: null }
const _hoisted_18 = { value: "true" }
const _hoisted_19 = { value: "false" }
const _hoisted_20 = { class: "col-lg-3 col-sm-6 text-end mt-4" }
const _hoisted_21 = { class: "d-inline-flex flex-wrap gap-3 justify-content-end" }
const _hoisted_22 = { class: "default-table-area style-two default-table-width" }
const _hoisted_23 = { class: "table-responsive" }
const _hoisted_24 = { class: "table align-middle" }
const _hoisted_25 = { class: "text-body" }
const _hoisted_26 = { class: "text-body" }
const _hoisted_27 = { class: "text-body" }
const _hoisted_28 = { class: "text-body text-center" }
const _hoisted_29 = { class: "text-body text-center" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "text-body" }
const _hoisted_32 = { class: "text-body" }
const _hoisted_33 = { class: "text-body" }
const _hoisted_34 = { class: "text-body" }
const _hoisted_35 = { class: "text-body" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { class: "" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "p-4 pt-lg-4" }
const _hoisted_43 = {
  id: "mdlSocialNetwork",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlSocialNetworkLabel",
  "aria-hidden": "true",
  size: "large"
}
const _hoisted_44 = { class: "modal-dialog modal-lg" }
const _hoisted_45 = { class: "modal-content" }
const _hoisted_46 = { class: "modal-header" }
const _hoisted_47 = {
  class: "modal-title fs-5",
  id: "mdlSocialNetworkLabel"
}
const _hoisted_48 = { class: "modal-body" }
const _hoisted_49 = { class: "mb-4" }
const _hoisted_50 = { class: "input-error small mb-1" }
const _hoisted_51 = { class: "mb-4" }
const _hoisted_52 = { class: "input-error small mb-1" }
const _hoisted_53 = { class: "input-error small mb-1" }
const _hoisted_54 = {
  id: "mdlDownload",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlDownloadLabel",
  "aria-hidden": "true",
  size: "large"
}
const _hoisted_55 = { class: "modal-dialog modal-md" }
const _hoisted_56 = {
  class: "modal-content",
  style: {"width":"155%"}
}
const _hoisted_57 = { class: "modal-body" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-lg-8" }
const _hoisted_60 = { class: "default-table-area style-two default-table-width" }
const _hoisted_61 = { class: "table-responsive" }
const _hoisted_62 = { class: "table align-middle" }
const _hoisted_63 = { class: "text-body" }
const _hoisted_64 = { class: "text-body" }
const _hoisted_65 = { class: "text-center" }
const _hoisted_66 = { class: "" }
const _hoisted_67 = {
  key: 0,
  class: "ps-2 border-0 bg-transparent lh-1 position-relative",
  title: "Descarga no disponible"
}
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  id: "mdlDuplicate",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlDuplicateLabel",
  "aria-hidden": "true",
  size: "large",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_70 = { class: "modal-dialog modal-lg" }
const _hoisted_71 = { class: "modal-content" }
const _hoisted_72 = { class: "modal-header" }
const _hoisted_73 = {
  class: "modal-title fs-5",
  id: "mdlDuplicateLabel"
}
const _hoisted_74 = { class: "modal-body" }
const _hoisted_75 = { class: "row" }
const _hoisted_76 = { class: "col-lg-6 col-sm-6" }
const _hoisted_77 = { class: "form-group mb-4" }
const _hoisted_78 = {
  key: 0,
  class: "input-error"
}
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-lg-6 col-sm-6" }
const _hoisted_81 = { class: "form-group mb-4" }
const _hoisted_82 = { class: "input-error" }
const _hoisted_83 = { class: "col-lg-6 col-sm-6" }
const _hoisted_84 = { class: "form-group mb-4" }
const _hoisted_85 = { class: "input-error" }
const _hoisted_86 = { class: "modal-footer" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = { key: 0 }
const _hoisted_89 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_90 = {
  key: 2,
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverlayLoader, { visible: _ctx.isLoading }, null, 8 /* PROPS */, ["visible"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "label text-secondary" }, "Nombre del Torneo", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.name) = $event)),
                    class: "form-control h-55",
                    placeholder: "Ingrese nombre"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.filters.name]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "label text-secondary strong" }, "Organizador", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.companyId) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example"
                  }, [
                    _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsCompany, (company, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: company.id,
                        key: i
                      }, _toDisplayString(company.name), 9 /* TEXT, PROPS */, _hoisted_10))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.companyId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { class: "label text-secondary" }, "Estado Torneo", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.tournamentStatusId) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example"
                  }, [
                    _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsTournamentStatus, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: i
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_14))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.tournamentStatusId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { class: "label text-secondary" }, "Estado Registro", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.isActive) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example"
                  }, [
                    _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.STATUS.ACTIVE), 1 /* TEXT */),
                    _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.STATUS.INACTIVE), 1 /* TEXT */)
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.isActive]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.getTournaments(_ctx.currentPage)), ["prevent"])),
                    class: "btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                  }, " Buscar "),
                  _createVNode(_component_RouterLink, { to: "/tournament/create" }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                      }, [
                        _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                          _createElementVNode("span", null, "Agregar Torneo")
                        ])
                      ], -1 /* HOISTED */)
                    ])),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ])
          ], 32 /* NEED_HYDRATION */)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("table", _hoisted_24, [
              _cache[31] || (_cache[31] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "#"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Torneo"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Organizador"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Fecha Inicio"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Fecha Fin"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Estado Torneo"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Estado Registro"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Nro. "),
                    _createElementVNode("br"),
                    _createTextVNode("Partidos")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode(" Creado"),
                    _createElementVNode("br"),
                    _createTextVNode(" por ")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode("creación")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Modificado "),
                    _createElementVNode("br"),
                    _createTextVNode("por")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode(" Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode(" modificación ")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Opciones")
                ])
              ], -1 /* HOISTED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1 + (_ctx.currentPage - 1) * _ctx.pageSize), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_25, _toDisplayString(item.company.name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_26, _toDisplayString(item.startDateTimeString), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_27, _toDisplayString(item.endDateTimeString), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_28, _toDisplayString(item.tournamentStatus.name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_29, [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (_ctx.confirmChangeStatus(item.id, item.isActive)),
                        class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeStatusClass(item.isActive)]),
                        role: "button"
                      }, _toDisplayString(item.isActive ? _ctx.STATUS.ACTIVE : _ctx.STATUS.INACTIVE), 11 /* TEXT, CLASS, PROPS */, _hoisted_30)
                    ]),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(item.totalMatches), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(item.createdBy), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_33, _toDisplayString(item.createdAtDateTimeString), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_34, _toDisplayString(item.updatedBy), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_35, _toDisplayString(item.updatedAtDateTimeString), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_RouterLink, {
                          to: `/tournament/edit/${item.id}`
                        }, {
                          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                            _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " edit ", -1 /* HOISTED */)
                          ]))]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                        (
                        item.tournamentStatus && item.tournamentStatus.id === 3
                      )
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                              onClick: ($event: any) => (_ctx.confirmCloseTournament(item.id)),
                              title: "Cerrar torneo"
                            }, [...(_cache[27] || (_cache[27] = [
                              _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " lock ", -1 /* HOISTED */)
                            ]))], 8 /* PROPS */, _hoisted_38))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("button", {
                          class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                          onClick: ($event: any) => (_ctx.socialNetworkModal(item.id))
                        }, [...(_cache[28] || (_cache[28] = [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " share ", -1 /* HOISTED */)
                        ]))], 8 /* PROPS */, _hoisted_39),
                        _createElementVNode("button", {
                          class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                          onClick: ($event: any) => (_ctx.downloadModal(item.id)),
                          title: "Lista de descargas"
                        }, [...(_cache[29] || (_cache[29] = [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " download ", -1 /* HOISTED */)
                        ]))], 8 /* PROPS */, _hoisted_40),
                        _createElementVNode("button", {
                          class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                          onClick: ($event: any) => (_ctx.duplicateModal(item.id, item.name)),
                          title: "Duplicar Torneo"
                        }, [...(_cache[30] || (_cache[30] = [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " content_copy ", -1 /* HOISTED */)
                        ]))], 8 /* PROPS */, _hoisted_41)
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_Pagination, {
              currentPage: _ctx.currentPage,
              pageSize: _ctx.pageSize,
              totalItems: _ctx.totalItems,
              "onUpdate:page": _ctx.fetchPage
            }, null, 8 /* PROPS */, ["currentPage", "pageSize", "totalItems", "onUpdate:page"])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("h1", _hoisted_47, " Redes Sociales: Torneo " + _toDisplayString(_ctx.tournament.name), 1 /* TEXT */),
            _cache[32] || (_cache[32] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1 /* HOISTED */))
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createCommentVNode(" Twitter "),
            _createElementVNode("div", _hoisted_49, [
              _cache[33] || (_cache[33] = _createElementVNode("label", { class: "form-label fw-bold" }, [
                _createElementVNode("i", { "data-feather": "twitter" }),
                _createTextVNode(" Twitter ")
              ], -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control mb-2",
                rows: "2",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formSocialNetwork.Twitter) = $event)),
                placeholder: "Escribe el texto para Twitter..."
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.formSocialNetwork.Twitter]
              ]),
              _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.errorsSocialNetwork.Twitter), 1 /* TEXT */),
              _createElementVNode("button", {
                class: "btn btn-outline-primary btn-sm",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validateAndSaveSocialNetwork('Twitter')))
              }, " Guardar Twitter ")
            ]),
            _createCommentVNode(" Facebook "),
            _createElementVNode("div", _hoisted_51, [
              _cache[34] || (_cache[34] = _createElementVNode("label", { class: "form-label fw-bold" }, [
                _createElementVNode("i", { "data-feather": "facebook" }),
                _createTextVNode(" Facebook ")
              ], -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control mb-2",
                rows: "2",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formSocialNetwork.Facebook) = $event)),
                placeholder: "Escribe el texto para Facebook..."
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.formSocialNetwork.Facebook]
              ]),
              _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.errorsSocialNetwork.Facebook), 1 /* TEXT */),
              _createElementVNode("button", {
                class: "btn btn-outline-primary btn-sm",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validateAndSaveSocialNetwork('Facebook')))
              }, " Guardar Facebook ")
            ]),
            _createCommentVNode(" WhatsApp "),
            _createElementVNode("div", null, [
              _cache[35] || (_cache[35] = _createElementVNode("label", { class: "form-label fw-bold" }, [
                _createElementVNode("i", { "data-feather": "whatsapp" }),
                _createTextVNode(" WhatsApp ")
              ], -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control mb-2",
                rows: "2",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formSocialNetwork.Whatsapp) = $event)),
                placeholder: "Escribe el texto para WhatsApp..."
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.formSocialNetwork.Whatsapp]
              ]),
              _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.errorsSocialNetwork.Whatsapp), 1 /* TEXT */),
              _createElementVNode("button", {
                class: "btn btn-outline-primary btn-sm",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validateAndSaveSocialNetwork('Whatsapp')))
              }, " Guardar WhatsApp ")
            ])
          ]),
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger text-white",
              "data-bs-dismiss": "modal"
            }, " Cerrar ")
          ], -1 /* HOISTED */))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _cache[40] || (_cache[40] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", {
              class: "modal-title fs-5",
              id: "mdlDownloadLabel"
            }),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary text-white",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.createTournamentUploadContentProcess && _ctx.createTournamentUploadContentProcess(...args)))
                }, " Generar ZIP ")
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("table", _hoisted_62, [
                  _cache[39] || (_cache[39] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { scope: "col" }, "#"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Nombre de Zip"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Estado"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, [
                        _createTextVNode(" Creado"),
                        _createElementVNode("br"),
                        _createTextVNode(" por ")
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, [
                        _createTextVNode(" Fecha "),
                        _createElementVNode("br"),
                        _createTextVNode("creación ")
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Opciones")
                    ])
                  ], -1 /* HOISTED */)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemDownload, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(index + 1), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.zipName || "-"), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.statusDescription), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_63, _toDisplayString(item.createdBy), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_64, _toDisplayString(item.createdAtDateTimeString), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, [
                            (!item.isDownload)
                              ? (_openBlock(), _createElementBlock("button", _hoisted_67, [...(_cache[37] || (_cache[37] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-secondary ps-2" }, " download_for_offline ", -1 /* HOISTED */)
                                ]))]))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                                  onClick: ($event: any) => (_ctx.downloadZip(item.id, item.zipName)),
                                  title: "Descargas ZIP"
                                }, [...(_cache[38] || (_cache[38] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary ps-2" }, " download_for_offline ", -1 /* HOISTED */)
                                ]))], 8 /* PROPS */, _hoisted_68))
                          ])
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ])
            ])
          ]),
          _cache[41] || (_cache[41] = _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger text-white",
              "data-bs-dismiss": "modal"
            }, " Cerrar ")
          ], -1 /* HOISTED */))
        ])
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_69, [
      _createElementVNode("div", _hoisted_70, [
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("h1", _hoisted_73, " Duplicar Torneo: " + _toDisplayString(_ctx.duplicateTournament.originalName), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("form", {
              onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _cache[42] || (_cache[42] = _createElementVNode("label", { class: "label text-secondary" }, "Nombre", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control h-45",
                      placeholder: "Ingresar el nombre del torneo",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.duplicateTournament.name) = $event)),
                      onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.clearError('name')))
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelText, _ctx.duplicateTournament.name]
                    ]),
                    (_ctx.errors)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(_ctx.errors.name), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _cache[43] || (_cache[43] = _createElementVNode("label", { class: "label text-secondary strong" }, "Fecha Inicio", -1 /* HOISTED */)),
                    _createVNode(_component_VueDatePicker, {
                      placeholder: "Fecha y hora",
                      modelValue: _ctx.duplicateTournament.startDate,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.duplicateTournament.startDate) = $event)),
                      format: "dd/MM/yyyy HH:mm",
                      "format-locale": _ctx.es,
                      onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.clearError('startDate'))),
                      "minutes-increment": 30,
                      "enable-time-picker": true,
                      "is-24": "",
                      teleport: ""
                    }, null, 8 /* PROPS */, ["modelValue", "format-locale"]),
                    _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.errors.startDate), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    _cache[44] || (_cache[44] = _createElementVNode("label", { class: "label text-secondary strong" }, "Fecha Fin", -1 /* HOISTED */)),
                    _createVNode(_component_VueDatePicker, {
                      placeholder: "Fecha y hora",
                      modelValue: _ctx.duplicateTournament.endDate,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.duplicateTournament.endDate) = $event)),
                      format: "dd/MM/yyyy HH:mm",
                      "format-locale": _ctx.es,
                      onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.clearError('endDate'))),
                      "minutes-increment": 30,
                      "enable-time-picker": true,
                      "is-24": "",
                      teleport: ""
                    }, null, 8 /* PROPS */, ["modelValue", "format-locale"]),
                    _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.errors.endDate), 1 /* TEXT */)
                  ])
                ])
              ]),
              _cache[45] || (_cache[45] = _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col-lg-6 col-sm-6" }, [
                  _createElementVNode("div", { class: "form-group mb-4" })
                ])
              ], -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("button", {
                  class: "btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4",
                  type: "submit",
                  disabled: _ctx.isLoading
                }, [
                  (!_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_88, " Duplicar Torneo"))
                    : _createCommentVNode("v-if", true),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_89))
                    : _createCommentVNode("v-if", true),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_90, "Procesando..."))
                    : _createCommentVNode("v-if", true)
                ], 8 /* PROPS */, _hoisted_87),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger text-white",
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.closeDuplicateTournament && _ctx.closeDuplicateTournament(...args)))
                }, " Cerrar ")
              ])
            ], 32 /* NEED_HYDRATION */)
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}